<template>
    <div class="wrapper">
        <div class="row">
            <div class="col-3">
                <p class="el-style attribute-name">Status:</p>
                <p class="el-style attribute-name">Sender:</p>
                <p class="el-style attribute-name">Contact List:</p>
                <p class="el-style attribute-name">Start:</p>
                <p class="el-style attribute-name">Stop:</p>
                <p class="el-style attribute-name">Minimal interval:</p>
                <p class="el-style attribute-name">Messages limit:</p>
                <p class="el-style attribute-name">Created:</p>
                <p class="el-style attribute-name">Updated:</p>
            </div>
            <div class="col-9">
                <p>{{ statusText }}</p>
                <p>{{ formatOutgoingNumber }}</p>
                <p>{{ contactList }}</p>
                <p>{{ start }}</p>
                <p>{{ stop }}</p>
                <p>{{ interval }}</p>
                <p>{{ maxMessages }}</p>
                <p>{{ createdAt }}</p>
                <p>{{ updatedAt }}</p>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      model: {
        type: Object,
        default: function () {
          return {};
        },
      },
    },

    computed: {
      /**
       * @return {string}
       */
      statusText() {
        return _.get(this, 'model.status_text');
      },

      /**
       * @return {string}
       */
      formatOutgoingNumber() {
        return _.get(this, 'model.outgoing_number.presentation');
      },

      /**
       * @return {string}
       */
      contactList() {
        return _.get(this, 'model.contact_list.name');
      },

      /**
       * @return {string}
       */
      start() {
        return this.formatDate(this.model.start_at);
      },

      /**
       * @return {string}
       */
      stop() {
        return this.formatDate(this.model.stop_at);
      },

      /**
       * @return {string}
       */
      createdAt() {
        return this.formatDate(this.model.created_at);
      },

      /**
       * @return {string}
       */
      updatedAt() {
        return this.formatDate(this.model.updated_at);
      },

      /**
       * @return {string}
       */
      interval() {
        const value = this.model.display_min_interval;

        return _.isNull(value) ? '-' : value;
      },

      /**
       * @return {string}
       */
      maxMessages() {
        const value = this.model.max_messages;

        return _.isNull(value) ? '-' : value;
      },
    },

    methods: {
      /**
       * @param {object|null} value
       */
      formatDate(value) {
        const datetime = _.get(value, 'datetime', null);

        return _.isNull(datetime)
          ? '-'
          : moment(datetime).format(config('format.moment.short.datetime'));
      },
    },
  }
</script>
